var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJudiIconWhiteColor = function SvgJudiIconWhiteColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-labelledby": "judi-icon-white-color",
    viewBox: "0 0 192 192"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96 192c53.019 0 96-42.981 96-96 0-53.02-42.981-96-96-96C42.98 0 0 42.98 0 96c0 53.019 42.98 96 96 96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0075C9",
    d: "M96.396 80.248v65.783c18.13 0 32.892-14.762 32.892-32.892s-14.762-32.891-32.892-32.891"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0195D7",
    d: "M89.759 113.238v32.892H73.313a16.405 16.405 0 0 1-16.446-16.446 16.406 16.406 0 0 1 16.446-16.446zM96.396 72.817c13.87 0 26.056 7.332 32.892 18.428V56.37a16.405 16.405 0 0 0-16.446-16.445A16.406 16.406 0 0 0 96.396 56.37z"
  })));
};
export default SvgJudiIconWhiteColor;